import React from 'react';
import { Box, Typography, Grid, useTheme, Slide, Fade } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import SchoolIcon from '@mui/icons-material/School';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import QuizIcon from '@mui/icons-material/Quiz';
// import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const features = [
  {
    icon: <SchoolIcon sx={{ fontSize: 80, color: '#ff6600' }} />,
    title: 'Expert Tutors',
    description: 'Learn from industry experts who bring real-world experience.',
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: 80, color: '#ff6600' }} />,
    title: 'Flexible Scheduling',
    description: 'Access courses anytime, anywhere on your schedule.',
  },
  // You can uncomment or add more features as needed
];

export default function FeaturesSection() {
  const theme = useTheme();
  const [ref, inView] = useInView({
    triggerOnce: false, // Allow re-trigger on scroll out/in
    threshold: 0.2,
  });

  return (
    <Box
      ref={ref}
      component="section"
      sx={{
        bgcolor: theme.palette.grey[50],
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 10 },
        textAlign: 'center',
        overflow: 'hidden',
        transition: 'all 0.6s ease',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          mb: 6,
          fontWeight: 700,
          color: '#ff6600',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 0.6s ease',
        }}
      >
        Why Choose Us?
      </Typography>

      <Grid container spacing={6} justifyContent="center">
        {features.map((feature, i) => (
          <Grid key={i} item xs={12} sm={6} md={3}>
            <Fade
              in={inView}
              timeout={600}
              style={{ transitionDelay: `${i * 200}ms` }}
              unmountOnExit
            >
              <Slide
                direction="up"
                in={inView}
                timeout={600}
                style={{ transitionDelay: `${i * 200}ms` }}
                unmountOnExit
              >
                <Box
                  sx={{
                    bgcolor: 'white',
                    p: 4,
                    borderRadius: 4,
                    boxShadow: '0 4px 24px rgba(0,0,0,0.1)',
                    minHeight: 280,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 8px 32px rgba(255, 102, 0, 0.3)',
                    },
                  }}
                >
                  <Box mb={3}>{feature.icon}</Box>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 700, color: '#333' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#555' }}>
                    {feature.description}
                  </Typography>
                </Box>
              </Slide>
            </Fade>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
